import { get } from "firebase/database";

export const getNombreCreadorGremio = (usuarios, idCreador) => {
  let strNombreCreador = "";

  if (!idCreador || !usuarios) {
    return process.env.REACT_APP_NOMBREPROYECTO || "";
  }

  // Buscar el usuario por su ID
  const usuarioEncontrado = usuarios.find((usuario) => usuario.idInterno === idCreador);

  if (usuarioEncontrado) {
    strNombreCreador = (usuarioEncontrado.Nombre || "") + " " + (usuarioEncontrado.Apellido || "");
    strNombreCreador = strNombreCreador.trim();
  }

  // Si no se encuentra el nombre, devolver el proyecto o vacío
  return strNombreCreador || process.env.REACT_APP_NOMBREPROYECTO || "";
};

export const traerComunidades = async (firebase) => {
  const snapshot = await get(firebase.getReferencia("Comunidad", null));
  let datos = [];
  snapshot.forEach((childSnapshot) => {
    const childKey = childSnapshot.key;
    const childData = childSnapshot.val();
    if (!childData.Borrado) {
      datos.push({
        label: childData.Nombre,
        value: childKey,

        Roles: [],
      });
    }
  });
  return datos;
};
